import api from './../libs/api';

export default {
  
  update: (id, formData) => {
    formData.append('_method', 'PUT');
    return new Promise((resolve, reject) => {
      api()
        .post(`/companies/${id}`, formData, {  // Use POST but Laravel will treat it as PUT
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          reject(new Error(`Failed with status: ${status}`));
        })
        .catch(error => {
          console.error('Update company error:', error);
          reject(error.response?.data || error);
        });
    });
  },

  get: async (queryString = '') => {
    try {
      const response = await api().get(`/companies${queryString}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getById: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/companies/${id}`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  add: (formData) => {
    return new Promise((resolve, reject) => {
      api()
        .post('/companies', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(({ status, data }) => {
          if (status === 201) resolve(data);
          reject(new Error(`Failed with status: ${status}`));
        })
        .catch(error => {
          console.error('Add company error:', error);
          reject(error.response?.data || error);
        });
    });
  },

  delete: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .delete(`/companies/${id}`)
        .then(({ status, data }) => {
          if (status === 204) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },
}